import { useMutation } from '@tanstack/react-query';

import type { SKUQuerySchema, SKUsMutationSchema } from '@/_pages/settings/inventory-kits/shared/schemas/skus';
import type { ApiError } from '@/_shared';
import { apiClient } from '@/_shared';

export const useCreateMutation = () =>
  useMutation<{ data: SKUQuerySchema }, ApiError, Omit<SKUsMutationSchema, 'id'>>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: `/api/v1/skus/`,
        payload,
      }),
  });

export const useUpdateMutation = () =>
  useMutation<{ data: SKUQuerySchema }, ApiError, SKUsMutationSchema>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: `/api/v1/skus/${payload.id}`,
        method: 'PUT',
        payload,
      }),
  });

export const useDeleteMutation = () =>
  useMutation<unknown, unknown, { id: string }>({
    mutationKey: ['SECONDARY_SKU_DELETE'],
    mutationFn: ({ id }) =>
      apiClient.request({
        endpoint: `/api/v1/skus/${id}`,
        method: 'DELETE',
      }),
  });
